// extracted by mini-css-extract-plugin
module.exports = {"Benefits__item":"styles_Benefits__item__c_QDp"};